import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Header, Grid, Form } from 'semantic-ui-react';
import { EssorButton } from 'components';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

class ShowBankAccounts extends Component {
  state = {
    value: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.retrieved)
      && nextProps.retrieved['hydra:member'][0].value !== prevState.value
      && nextProps.retrieved['hydra:member'][0].name === 'BANK_ACCOUNTS'
    ) {
      return {
        value: nextProps.retrieved['hydra:member'][0].value,
      };
    }

    return null;
  }

  render() {
    const { value } = this.state;

    const { loading, selectedOffice, t } = this.props;

    return (
      <div className="section-container">
        <div className="section-general">
          <div className="option-buttons-container clearfix">
            <Header as="h3">{t('companiesBankAccounts')}</Header>
            <EssorButton as={Link} to={`/offices/${selectedOffice.id}/settings/bank-accounts/edit`} type="edit" size="tiny" floated="right">
              {t('buttonEdit')}
            </EssorButton>
          </div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={loading} size="small">
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formBankName')}</label>
                      <h5 className="informative-field">
                        {value && (value.bankName === '' ? '-' : value.bankName)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formIBAN')}</label>
                      <h5 className="informative-field">
                        {value && (value.IBAN === '' ? '-' : value.IBAN)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formBIC')}</label>
                      <h5 className="informative-field">
                        {value && (value.BIC === '' ? '-' : value.BIC)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.officeSettings.show.error,
  loading: state.officeSettings.show.loading,
  retrieved: state.officeSettings.show.retrieved,

  selectedOffice: state.userCompanies.select.selectedOffice,
});

const Main = connect(mapStateToProps)(ShowBankAccounts);

export default withTranslation()(withRouter(Main));
